import { ColorV2 } from "config/colors";
import styled from "styled-components";

export const SummaryStrip = styled.div`
  display: flex;
  align-items: stretch;
  gap: 16px;
  padding: 14px 16px;
  border-radius: 20px;
  background: ${ColorV2.White};
  overflow-x: auto;
`;

export const StaffHeaderRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 16px;
`;

export const StaffHeaderDateCard = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 14px 16px;
  border-radius: 20px;
  background: ${ColorV2.White};
`;

export const StaffHeaderCompanyCardSlot = styled.div`
  display: flex;
  flex: 1;
`;
